<script>
	import axios from 'axios';
	import mixin from '../../mixin';

    import Table from './Table.vue';

	export default {
        components: {
            Table,
        },
		mixins: [mixin],
		props: {
			idFromUrl: {
				type: String,
				default: null,
			},
		},
		data() {
			return {
				arrangementsData: [],
				columns: [
                    {
                        label: this.$store.getters.getRightText('dossierdetailTableHeadArrangementsCaseNumber'),
                        field: 'dossiernummer',
                    },
                    {
                        label: this.$store.getters.getRightText('dossierdetailTableHeadArrangementsCaseStartDate'),
						field: 'startdatumdossier',
                        type: 'date',
                    },
                    {
                        label: this.$store.getters.getRightText('dossierdetailTableHeadArrangementsPhase'),
                        field: 'fase',
                    },
                    {
						label: this.$store.getters.getRightText('dossierdetailTableHeadArrangementsFirstPeriod'),
                        field: 'eerstetermijn',
                        type: 'nullableDate',
                    },
                    {
                        label: this.$store.getters.getRightText('dossierdetailTableHeadArrangementsPartialAmount'),
                        field: 'deelbedrag',
                        type: 'currency',
                    },
                    {
                        label: this.$store.getters.getRightText('dossierdetailTableHeadArrangementsTermPeriod'),
                        field: 'termijnperiode',
                    },
                    {
                        label: this.$store.getters.getRightText('dossierdetailTableHeadArrangementsNumberOfTerms'),
                        field: 'aantaltermijnen',
					},
                    {
                        label: this.$store.getters.getRightText('dossierdetailTableHeadArrangementsLastTermDate'),
                        field: 'laatstetermijndatum',
                        type: 'nullableDate',
                    },
				],
			};
		},
        computed: {
            sortedArrangementsData() {
                return this.arrangementsData.sort((a, b) => {
                    return new Date(b.startdatumdossier) - new Date(a.startdatumdossier);
				});
            },
        },
		async mounted() {
			await this.fetchData(this.idFromUrl);
		},
		methods: {
			async fetchData(idFromURL) {
				try {
					const response = await axios.get(
						`/api/dossiers/${idFromURL}/regelingen`
					);
					if (response ?? response.data) {
						this.arrangementsData = response.data;
					} else {
						console.error('Invalid data received:', response);
					}
				} catch (error) {
					console.error('Error fetching data:', error);
				}
			},
		},
	};
</script>

<template>
	<div class="arrangements">
		<div class="arrangements__title">
			<p>
				<i class="fa-regular fa-handshake"></i>
				{{ $store.getters.getRightText('dossierdetailTableTitleArrangementsArrangements') }}
				<span>({{ arrangementsData.length }})</span>
			</p>
		</div>
		<Table :data="sortedArrangementsData"
			   :columns="columns"
			   :exportable="false"
			   :sortable="false"
			   :freezable="false"
			   :scrollable="true"
			   :text-manipulation="false"
			   :hoverable="true"
			   :alt-style="true" />
	</div>
</template>
